import { render } from "./PartnerCreate.vue?vue&type=template&id=9215081c&scoped=true"
import script from "./PartnerCreate.vue?vue&type=script&lang=js"
export * from "./PartnerCreate.vue?vue&type=script&lang=js"

import "./PartnerCreate.vue?vue&type=style&index=0&id=9215081c&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9215081c"]])

export default __exports__